/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type RegulatoryNotificationDtoStatus = typeof RegulatoryNotificationDtoStatus[keyof typeof RegulatoryNotificationDtoStatus];


export const RegulatoryNotificationDtoStatus = {
  pending: 'pending',
  submitted: 'submitted',
  acknowledged: 'acknowledged',
  rejected: 'rejected',
} as const;
